import { GetFingerprint } from '../utils/fingerprint'
import service, { TOKEN_KEY } from '../utils/request'
import { FINGER_KEY } from '../utils/fingerprint'

// 登录请求参数类型
export interface LoginRequest {
  username: string
  password: string
  finger: string
  totp?: string
}

// 登录响应类型
export interface LoginResponse {
  token?: string
  needTotp?: boolean // 新增字段，表示需要TOTP验证
  message?: string
}

class Login {
  // 登录方法
  async login(loginData: LoginRequest): Promise<LoginResponse> {
    // 使用工具函数获取指纹
    loginData.finger = await GetFingerprint()

    /*
     * 根据request.ts中的响应拦截器，成功响应后会返回response.data.data
     * 所以这里需要明确给service.post指定返回类型
     */
    const data: any = await service.post('/admin/login', loginData)

    // 尝试从返回数据中获取token
    let token = ''

    if (data) {
      // 根据不同可能的返回结构尝试获取token
      if (typeof data === 'string') {
        token = data // 如果直接返回了token字符串
      } else if (typeof data === 'object') {
        // 检查是否需要TOTP验证
        if (data.totp === true) {
          // 需要TOTP验证，返回特殊响应
          return {
            needTotp: true,
            message: '请输入TOTP验证码',
          }
        }

        if (data.token) {
          token = data.token // 如果返回了{token: "xxx"}结构
        }
      }
    }

    if (token) {
      // 保存token到本地存储
      localStorage.setItem(TOKEN_KEY, token)

      // 获取URL中的redirect参数
      const urlParams = new URLSearchParams(window.location.search)
      // 登录成功后跳转到指定的重定向URL
      window.location.href = urlParams.get('redirect') || '/'

      return { token }
    }

    throw new Error('登录失败：无法获取有效token')
  }

  // 注销方法
  logout(): void {
    // 清除存储中的认证信息
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(FINGER_KEY)
    sessionStorage.removeItem(TOKEN_KEY)
    sessionStorage.removeItem(FINGER_KEY)

    // 不直接跳转，而是返回，让调用者决定如何跳转
    // 登出后重定向的处理将由Router或调用者处理
  }

  // 执行登出后的重定向
  redirectToLogin(): void {
    // 使用延迟执行跳转，确保其他操作已完成
    setTimeout(() => {
      window.location.href = '/auth/login'
    }, 100)
  }
}

// 导出单例实例
export const login = new Login()
